import React from 'react'
import { LgySection, LgySubsection, LgySubsubsection } from 'app/components/util/lgy-section/LgySection'
import LgyField from 'app/components/util/lgy-field/LgyField'

const getUserApplicationsFromAuthorizations = (authorizations) =>
  authorizations.filter(application => application.startsWith('APPLICATION_')).map((role) => role.substring(12)).sort()

const getUserRolesFromAuthorizations = (authorizations) =>
  authorizations.filter(authorization => authorization.startsWith('ROLE_')).map((role) => role.substring(5)).sort()

export const AccountPermissions = ({ user }) => {
  const applications = user.authorizations ? getUserApplicationsFromAuthorizations(user.authorizations) : []
  const roles = user.authorizations ? getUserRolesFromAuthorizations(user.authorizations) : []

  return <LgySection header='Account Permissions'>
    <LgySubsection header='Applications'>
      {applications.map(app => <div key={app}>{app}</div>)}
    </LgySubsection>
    <LgySubsection header='Roles'>
      {roles.map(role => <div key={role}>{role}</div>)}
    </LgySubsection>
    <LgySubsection header='Entities'>
      {user.entities &&
        user.entities.sort((a, b) => a.application.localeCompare(b.application))
          .map(entity => <LgySubsubsection key={entity.id} header={entity.name}>
            <LgyField label='Application' value={entity.application} />
            {Object.keys(entity.values).map(key => <LgyField key={key} label={key} value={entity.values[key]} />)}
          </LgySubsubsection>)}
    </LgySubsection>

  </LgySection>
}

export default AccountPermissions
